module.exports = require('./dist/cleave-react-node.js');



// WEBPACK FOOTER //
// ./node_modules/cleave.js/react.js